import Api from '@/services/Index';

const studentGetAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/infirmary/users/students', config);
}
const  showStudent = async (id)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/infirmary/users/get-user-detail/'+id);
}
const  updateStudent = async (id,formData)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/infirmary/users/update-user-detail/'+id,formData);
}




const personelGetAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/infirmary/users/staffs', config);
}




const  guestGetAll = async (config)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/infirmary/users', config);
}
const  storeGuest = async (data)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/infirmary/users/create-guest-user', data);
}
const  showGuest = async (id)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/infirmary/users/'+id);
}
const  updateGuest = async (id,data)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/infirmary/users/'+id,data);
}





const  infirmaryRecords = async (formData)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/infirmary/records',formData);
}

const  getInfirmaryRecords = async (config)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/infirmary/records',config);
}
const  show = async (id,formData)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/infirmary/records/'+id,formData);
}
const  del = async (id)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/infirmary/records/'+id);
}

export default {
    studentGetAll,
    guestGetAll,
    storeGuest,
    showGuest,
    updateGuest,
    showStudent,
    updateStudent,
    personelGetAll,
    infirmaryRecords,
    getInfirmaryRecords,
    show,
    del
}
